export const MealPackagingPivot = (json: IMealPackagingPivot): IMealPackagingPivotModel => {
	const fromJSON = () => {
		const {
			description_compartment_1,
			description_compartment_2,
			description_compartment_3,
			packaging_type_id,
			...rest
		} = json
		return {
			descriptionCompartment1: description_compartment_1,
			descriptionCompartment2: description_compartment_2,
			descriptionCompartment3: description_compartment_3,
			id: packaging_type_id,
			...rest,
		}
	}

	return { ...fromJSON() }
}

export const mealPackagingPivotToJSON = (payload: Partial<IMealPackagingPivotModel>): Partial<IMealPackagingPivot> => {
	const { id, pivot } = payload

	return {
		description: pivot.description,
		packaging_type_id: id,
		description_compartment_1: pivot.descriptionCompartment1,
		description_compartment_2: pivot.descriptionCompartment2,
		description_compartment_3: pivot.descriptionCompartment3,
	}
}

export const MealPackagingType = (json: IMealPackagingType): IMealPackagingTypeModel => {
	const { meal_kind, compartments_qty, name, is_active, created_at, updated_at, pivot, subtype, ...rest } = json

	return {
		...rest,
		isActive: is_active,
		name: LangContentToModel(name),
		subtype,
		mealKind: meal_kind,
		compartmentsQty: compartments_qty,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
		pivot: pivot ? MealPackagingPivot(pivot) : null,
	}
}

export const mealPackagingTypeToJSON = (obj: Partial<IMealPackagingTypeModel>): Partial<IMealPackagingType> => {
	const { isActive, ...rest } = obj
	return {
		is_active: isActive,
		...rest,
	}
}
